export default {
    name: 'v5-icon-female',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M485.333 768v-43.765C321.077 710.688 192 573.088 192 405.333c0-176.736 143.264-320 320-320s320 143.264 320 320c0 164.107-123.52 299.35-282.667 317.846V768H640a32 32 0 010 64h-90.667v77.333a32 32 0 01-64 0V832H384a32 32 0 010-64h101.333zM512 661.333c141.387 0 256-114.613 256-256s-114.613-256-256-256-256 114.614-256 256 114.613 256 256 256z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
